import { useReactiveVar } from "@apollo/client";
import { stateVar } from "common/Auth/Utils/state";
export var use = function () {
    var status = useReactiveVar(stateVar);
    return getMessageFromStatus(status);
};
export var getMessageFromStatus = function (status) {
    if (status.kind !== "LoggedOut")
        return "Nothing";
    if (status.reason === "EXPLICIT")
        return "Nothing";
    return status.feedback ? "AuthError" : "Nothing";
};
